export default class NetworkDetailsController {
  constructor($q, $state, $scope, AuthenticationService, UIService, NetworkService, Network, Abrangencia, Papel, Investigador) {
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.NetworkService = NetworkService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Network = Network;
    this.Abrangencia = Abrangencia;
    this.Papel = Papel;
    this.Investigador = Investigador;

    this.showEstadosPanel = false;

    this.loaded = false;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  loadData = () => {
    this.loaded = false;
    this.Network.findOne({
      filter: {
        where: {
          id: this.id
        },
        include: ['criadoPor', 'atualizadoPor', 'abrangencia', 'papel', 'investigador']
      }
    }).$promise.then(res => {
      this.data = res;

      this.loaded = true;
    }).catch((error) => {
      console.log(error);
      this.$state.go('app.network.list');
      this.UI.addToast('Erro ao carregar rede. Verifique a ligação');
    });
  };

  editDetalhes = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then(investigadores => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      this.Papel.find({}).$promise.then(papeis => {
        this.Abrangencia.find({}).$promise.then((abrangencias) => {
          wait.close();
          let options = {
            size: 'lg',
            template: require('./details.dialog.html'),
            controller: ['$scope', ($scope) => {
              $scope.label = "Editar Rede";
              $scope.isNew = false; // Do not show observacoes when editing
              $scope.network = angular.copy(this.data);
              $scope.abrangencias = abrangencias;
              $scope.papeis = papeis;
              $scope.investigadores = investigadores;
              $scope.simnao = this.simnao;

              // Current year as max be able to add ano
              $scope.year = moment().format('YYYY');

              $scope.auxAbrangencia = {
                selected: $scope.network.abrangencia ? $scope.network.abrangencia : null,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxPapel = {
                selected: $scope.network.papel ? $scope.network.papel : null,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxInvestigador = {
                selected: $scope.network.investigador ? $scope.network.investigador : null,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxInterdisciplinary = {
                selected: $scope.network.interdisciplinary ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxDevelopingCountries = {
                selected: $scope.network.developingCountries ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };

              // Infinite Scroll magic
              $scope.addMoreItems = (infiniteScroll) => {
                infiniteScroll.currentItems += infiniteScroll.numToAdd;
              };

              $scope.ok = () => {
                $scope.$close($scope);
              };

              $scope.cancel = () => $scope.$dismiss('cancel');
            }]
          };

          this.UI.showDialog(options).then(res => {
            this.loaded = false;
            if (res) {
              this.data.designacao = res.network.designacao;
              this.data.anoInicio = res.network.anoInicio;
              this.data.anoFim = res.network.anoFim || null;
              this.data.descricao = res.network.descricao;
              this.data.www = res.network.www;
              this.data.interdisciplinary = res.auxInterdisciplinary.selected.value;
              this.data.developingCountries = res.auxDevelopingCountries.selected.value;


              this.data.abrangencia = res.auxAbrangencia.selected;
              this.data.abrangenciaId = res.auxAbrangencia.selected.id;
              this.data.papel = res.auxPapel.selected;
              this.data.papelId = res.auxPapel.selected.id;
              this.data.investigador = res.auxInvestigador.selected;
              this.data.investigadorId = res.auxInvestigador.selected.id;

              this.data.atualizadoPorId = this.user.id;
              this.data.atualizadoa = moment().format();

              this.Network.upsert(this.data).$promise.then((res) => {
                this.UI.addToast("Rede atualizada com sucesso");
                this.loadData();
              }).catch((error) => {
                console.log(error);
                this.UI.showAlert("Erro ao atualizar rede. Verifique a ligação");
                this.loaded = true;
              });
            }
          });
        }).catch((error) => {
          wait.close();
          console.log(error);
          this.UI.addToast("Não foi possível ler Abrangências. Verifique a ligação");
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler Papéis ISR. Verifique a ligação");
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Investigadores. Verifique a ligação");
    });
  };

  editObservacoes = () => {
    let options = {
      size: 'lg',
      template: require('./observacoes.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Observações";
        $scope.observacoes = angular.copy(this.data.observacoes);

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;
      if (ok.observacoes !== 0 && !ok.observacoes)
        ok.observacoes = null;
      this.data.observacoes = ok.observacoes;
      this.data.atualizadoPorId = this.user.id;
      this.data.atualizadoa = moment().format();

      this.Network.upsert(this.data).$promise.then((res) => {
        this.UI.addToast("Observações atualizadas com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar rede. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  // Permissions
  // read: (ownPermission, allowAll, adminPermission, users)
  // edit: (ownPermission, allowOwn, adminPermission, users)
  canReadGeneral = () => this.NetworkService.canRead('redeRead', true, 'redeReadAny', this.NetworkService.getInvestigadorUserId(this.data));
  canEditGeneral = () => this.NetworkService.canEdit('redeEdit', true, 'redeEditAny', this.NetworkService.getInvestigadorUserId(this.data));

  canReadAdicional = () => this.NetworkService.canRead('redeReadAdicional', true, 'redeReadAdicionalAny', this.NetworkService.getInvestigadorUserId(this.data));
  canEditAdicional = () => this.NetworkService.canEdit('redeEditAdicional', true, 'redeEditAdicionalAny', this.NetworkService.getInvestigadorUserId(this.data));

}

NetworkDetailsController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'NetworkService', 'Network', 'Abrangencia', 'Papel', 'Investigador'];
